export default __webpack_public_path__ + "static/media/ferven-hero.b3227fa3.mp4";